import { Paper } from '@mui/material'

type FormCardProps = {
  children: JSX.Element
}

export function FormCard(props: FormCardProps) {
  return <Paper elevation={0}>{props.children}</Paper>
}
